import { render, staticRenderFns } from "./addList.vue?vue&type=template&id=15651551&scoped=true&"
import script from "./addList.vue?vue&type=script&lang=js&"
export * from "./addList.vue?vue&type=script&lang=js&"
import style0 from "./addList.vue?vue&type=style&index=0&id=15651551&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15651551",
  null
  
)

export default component.exports